import { render, staticRenderFns } from "./BalancePeriodTotal.vue?vue&type=template&id=b869e158&scoped=true"
import script from "./BalancePeriodTotal.vue?vue&type=script&lang=js"
export * from "./BalancePeriodTotal.vue?vue&type=script&lang=js"
import style0 from "./BalancePeriodTotal.vue?vue&type=style&index=0&id=b869e158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b869e158",
  null
  
)

export default component.exports